import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Link,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  Alert,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import background from "../../assets/img/header/img-7.png";
import logo from "../../assets/img/logo.jpg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "../../config/api";
import emailjs from "emailjs-com";
import { useAuth } from "../../context/AuthContext";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";

export default function Register() {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const { login } = useAuth();
 const { fetchMe } = useAuth();

  const [form, setForm] = useState({
    name: "",
    lastName: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
const handleBack = () => navigate(-1);


  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    if (form.password !== form.confirmPassword) {
      setError("Las contraseñas no coinciden");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const payload = {

        name: form.name,
        lastName: form.lastName,


        phone: form.phone,
        email: form.email,
        password: form.password,
      };

      const { data } = await axios.post(
        `${API_BASE}/register`,
        payload
      );

     localStorage.setItem("token", data.token);
navigate("/"); // o donde quieras enviarlo cuando ya esté logueado

    } catch (err) {
      setError(err.response?.data?.message || "Error al registrar usuario");
    }

    setLoading(false);
  };
const handleLoginSuccess = async (response) => {
  setLoading(true);

  try {
    // Validación inicial de la credencial de Google
    if (!response?.credential) {
      throw new Error('No se recibió la credencial de Google.');
    }

    // Enviar token al backend para autenticación
    const { data } = await axios.post(
      `${API_BASE}/auth/google`,
      { token: response.credential },
      { headers: { 'Content-Type': 'application/json' } }
    );

    // Validación de la respuesta del backend
    const { token, userId, role, name, email } = data;
    if (!token || !userId || !role) {
      throw new Error('La respuesta de autenticación es inválida.');
    }

    // Guardar información del usuario en localStorage
    localStorage.setItem('token', token);
    localStorage.setItem('userId', userId);
    localStorage.setItem('role', role);

    // Actualizar estado global de autenticación
    login(token);

    // =============================
    // ENVÍO DE CORREO AL CLIENTE
    // =============================
    if (email) {
      try {
        await emailjs.send(
          "service_zsccg3j",
          "template_2fof6nr",
          { name, email },
          "9016C6iHqY8pBLbs1"
        );
      } catch (emailError) {
        console.error('Error enviando el correo al cliente:', emailError);
        // Aquí podrías decidir notificar al usuario o reintentar
      }
    } else {
      console.warn('No se proporcionó correo del usuario, no se envió el email.');
    }

    // Obtener información adicional del usuario
    fetchMe(token);

    // Redirigir al inicio evitando que vuelva al login
    navigate('/', { replace: true });

  } catch (error) {
    console.error('Error en autenticación con Google OAuth:', error);
    // Aquí puedes mostrar un toast o modal con mensaje amigable al usuario
  } finally {
    setLoading(false);
  }
};
  return (
      <GoogleOAuthProvider clientId="612012951762-nj766julnqv94n6dpfl862ro0ufh1mou.apps.googleusercontent.com">

    <Box
      sx={{
        display: "flex",
        height: "100dvh", // d = moderno (mejor en móviles)
        overflow: "hidden", // evita scroll global
        bgcolor: "#fff",
      }}
    >
      {/* FLECHA VOLVER */}
      <IconButton
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          color: "#000",
          zIndex: 10,
        }}
        onClick={handleBack}
      >
        <ArrowBackIcon />
      </IconButton>

      {/* LEFT SIDE (FORM) */}
      <Container
        maxWidth="sm"
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          py: 4,
          overflowY: "auto", // si hay overflow, solo aquí
        }}
      >
        {/* LOGO */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <img
            src={logo}
            alt="Logo"
            style={{
              height: "100px",
              width: "100px",
              objectFit: "cover",
              borderRadius: "100%",
            }}
          />
        </Box>

        <Typography
          variant="h5"
          fontWeight={600}
          mb={2}
          sx={{ textAlign: "center" }}
        >
          Crear cuenta
        </Typography>
<GoogleLogin
  onSuccess={handleLoginSuccess}
  onError={() => {
    setError('Error al iniciar sesión con Google');
  }}
  width="100%"
  useOneTap={false}
/>
    {/* Separador "o" */}
           <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
             <Box sx={{ flex: 1, height: "1px", bgcolor: "#ccc" }} />
             <Typography sx={{ mx: 2, color: "#999", fontSize: 14 }}>o</Typography>
             <Box sx={{ flex: 1, height: "1px", bgcolor: "#ccc" }} />
           </Box>

        {/* FORM */}
        <TextField
          fullWidth
           size="small"
          label="Nombre"
          name="name"
          value={form.firstName}
          onChange={handleChange}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
           size="small"
          label="Apellidos"
          name="lastName"
          value={form.lastName}
          onChange={handleChange}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
           size="small"
          label="Teléfono"
          name="phone"
          value={form.phone}
          onChange={handleChange}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
           size="small"
          label="Email"
          name="email"
          value={form.email}
          onChange={handleChange}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
           size="small"
          label="Contraseña"
          type={showPassword ? "text" : "password"}
          name="password"
          value={form.password}
          onChange={handleChange}
          sx={{ mb: 2 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <TextField
          fullWidth
           size="small"
          label="Confirmar contraseña"
          type={showConfirm ? "text" : "password"}
          name="confirmPassword"
          value={form.confirmPassword}
          onChange={handleChange}
          sx={{ mb: 2 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowConfirm(!showConfirm)}>
                  {showConfirm ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Button
          variant="contained"
          fullWidth
          disabled={loading}
          sx={{
            bgcolor: "#000",
            height: 45,
            borderRadius: 1.5,
            fontWeight: 600,
            "&:hover": { bgcolor: "#000" },
          }}
          onClick={handleSubmit}
        >
          {loading ? "Registrando..." : "Registrarse"}
        </Button>

        <Typography color="text.secondary" mt={2} sx={{ textAlign: "center" }}>
          ¿Ya tienes una cuenta?{" "}
          <Link href="/iniciar-sesión" underline="hover">
            Iniciar sesión
          </Link>
        </Typography>
      </Container>

      {/* RIGHT SIDE - RESPONSIVE */}
      <Box
        sx={{
          width: "50%",
          display: { xs: "none", md: "flex" },
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
    </Box>
      </GoogleOAuthProvider>

  );
}
